import { render, staticRenderFns } from "./NationalTrademarkTransactionReportDetail.vue?vue&type=template&id=11297c40&"
import script from "./NationalTrademarkTransactionReportDetail.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkTransactionReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkTransactionReportDetail.vue?vue&type=style&index=0&id=11297c40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports